import React, {useState, useEffect} from 'react';
import {ContentHeader} from '@components';
import Card from 'react-bootstrap/Card';
import {Button} from 'react-bootstrap';
import {toast} from 'react-toastify';
import {useSelector} from 'react-redux';
import * as AuthService from '../services/auth';
import Table from 'react-bootstrap/Table';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import ModalAddBatch from './modal/ModalAddBatch';
import ModalSetBatch from './modal/ModalSetBatch';
import ModalConfirm from './modal/ModalConfirm';
import Switch from 'react-bootstrap-switch';
import ClockLoader from "react-spinners/ClockLoader";

const bg = ['bg-info', 'bg-primary', 'bg-warning', 'bg-danger'];
export default function Manage() {
  const user = useSelector((state: any) => state.auth.currentUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [mode, setMode] = useState('');
  const [title, setTitle] = useState('');
  const [hide, setHide] = useState('overlay dark');
  const [campaignData, setCampaignData] = useState<any[]>([]);
  const [campaignItem, setCampaignItem] = useState<any>({});
  const [pendingData, setPendingData] = useState<any[]>([]);
  const [showMd1, setShowMd1] = useState(false); //CREATE,UPDATE
  const [showMd2, setShowMd2] = useState(false); //SET BATCH
  const [showMd3, setShowMd3] = useState(false); //DELETE

  useEffect(() => {
    const fetchInit = async () => {
      try {
        await downloadCampaignWs();
        await downloadPendingWs();
        await downloadSuperAdminWs();
      } catch {}
    };

    fetchInit();
  }, []);

  const downloadPendingWs = async () => {
    try {
      const pending = await AuthService.downloadPending();
      if (pending.error) throw 'timeout';
      setPendingData(pending);
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const downloadSuperAdminWs = async () => {
    try {
      const admin = await AuthService.downloadSuperAdmin();
      if (admin.error) throw 'timeout';
      if (admin.find((e : any)=>(e.ADMIN_ID_EMP === user.ID_EMP))) setHide('d-none');
      else setHide('overlay dark');
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const handleResend = async (country_code: string) => {
    setLoading(true);
    try {
      if (country_code === 'MY' || country_code === 'HK' || country_code === 'MO') {
        toast.warn(`${country_code} is not allowed to resend.`);
      } else {
        await AuthService.resendVoucher(country_code);
        await downloadPendingWs();
      }
      setLoading(false);
    } catch (error: any) {}
  };

  const handleMdNew = () => {
    setTitle('+ new batch');
    setMode('create');
    setCampaignItem({});
    setShowMd1(true);
  };

  const handleMdUpdate = (item: any) => {
    setTitle('+ refill batch');
    setMode('refill');
    setCampaignItem(item);
    setShowMd1(true);
  };

  const handleMdUpdate2 = (item: any) => {
    setTitle('update batch');
    setMode('update');
    setCampaignItem(item);
    setShowMd1(true);
  };

  const handleMdSet = (item: any) => {
    setCampaignItem(item);
    setShowMd2(true);
  };

  const downloadCampaignWs = async () => {
    try {
      const params = await AuthService.downloadCampaign();
      if (params.error) throw 'timeout';
      setCampaignData(params);
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const addCampaignWs = async (input: any, file: File) => {
    try {
      console.log(input);
      let params: any;
      if (file) {
        params = await AuthService.addCampaign2(input, file);
      } else {
        params = await AuthService.addCampaign(input);
      }
      if (params.error) throw 'timeout';
      setShowMd1(false);
      setShowMd2(false);
      downloadCampaignWs();
      toast.success('Add batch is succeed!');
    } catch (error: any) {
      toast.error('Add batch is Failed!');
    }
  };

  const updateCampaignWs = async (input: any, file: any) => {
    try {
      console.log(input);
      let params: any;
      params = await AuthService.updateCampaign(input, file);
      if (params.error) throw 'timeout';
      setShowMd1(false);
      setShowMd2(false);
      downloadCampaignWs();
      toast.success('Update batch is succeed!');
      return true;
    } catch (error: any) {
      toast.error('Update batch is Failed!');
      return false;
    }
  };

  const deleteCampaignWs = async (input: any) => {
    try {
      let params: any;
      console.log(input);
      params = await AuthService.deleteCampaign(input);
      if (params.error) throw 'timeout';
      downloadCampaignWs();
      toast.success('Delete batch is succeed!');
      setShowMd3(false);
      return true;
    } catch (error: any) {
      toast.error('Delete batch is Failed!');
      setShowMd3(false);
      return false;
    }
  };

  const confirmDeleteCampaignWs = (input: any) => {
    setCampaignItem(input);
    setShowMd3(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setShowMd3(false);
  };



  const updateData = (
    prevState: any[],
    CAMPAIGN: any,
    state: boolean | null
  ): any[] => {
    const newData = prevState.reduce((prev, curr) => {
      if (curr.CAMPAIGN === CAMPAIGN) {
        prev.push({...curr, IS_ACTIVE: state ? 1 : 0});
      } else {
        prev.push(curr);
      }
      return prev;
    }, []);
    return newData;
  };

  return (
    <div>
      <ModalConfirm showModal={showMd3} confirmModal={deleteCampaignWs} hideModal={hideConfirmationModal} item={campaignItem}/>
      <Modal
        show={showMd2}
        fullscreen={'md-down'}
        onHide={() => setShowMd2(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Set Next Batch</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalSetBatch
            onUpdate={updateCampaignWs}
            item={campaignItem}
          ></ModalSetBatch>
        </Modal.Body>
      </Modal>
      <Modal
        show={showMd1}
        fullscreen={'md-down'}
        onHide={() => setShowMd1(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalAddBatch
            onAdd={addCampaignWs}
            onUpdate={updateCampaignWs}
            mode={mode}
            title={title}
            item={campaignItem}
          ></ModalAddBatch>
        </Modal.Body>
      </Modal>
      <ContentHeader title="Manage Campaigns" />
      <section className="content">
        <div className="container-fluid">
          <div className="row col-md-12">
            {pendingData.map((e, i) => {
              return (
                <div className="col-lg-3 col-4">
                  <div className={`small-box ${bg[i]}`}>
                    <div className={isLoading ? 'overlay dark' : 'd-none'}>
                      <ClockLoader color="#c4c4c4" />
                      {/* <i className="fas fa-3x fa-sync-alt"></i> */}
                    </div>
                    <div className="inner">
                      <h3>{e.SUM_PENDING}</h3>
                      <p>Pending SMS : {e.COUNTRY_CODE}</p>
                    </div>
                    <div className="icon">
                      <i className="ion ion-android-textsms" />
                    </div>
                    <a
                      onClick={() => {
                        handleResend(e.COUNTRY_CODE);
                      }}
                      className="small-box-footer btn"
                      aria-disabled="true"
                    >
                      Resend Me <i className="fas fa-arrow-circle-right" />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
          <Card className="card">
            <div className={hide}>
              <span style={{color: 'white', fontSize: 30}}>READ ONLY MODE</span>
            </div>
            <Card.Header className="d-flex">
              <div className="p-10">Current Campaign</div>
              <div className="ml-auto">
                <Button
                  className="btn-xs"
                  variant="outline-primary"
                  onClick={handleMdNew}
                >
                  + new batch
                </Button>
              </div>
            </Card.Header>
            <Table striped>
              <thead>
                <tr>
                  <th></th>
                  <th className='d-none d-sm-table-cell'>#</th>
                  <th className='d-none d-sm-table-cell'>Country</th>
                  <th>Batch ID</th>
                  <th className='d-none d-sm-table-cell'>Campaign</th>
                  <th className='d-none d-lg-table-cell'>Exchange Rate</th>
                  <th className='d-none d-lg-table-cell'>Balance</th>
                  <th className='d-none d-lg-table-cell'>Quota</th>
                  <th>Next Batch ID</th>
                  <th className='d-none d-sm-table-cell'>View</th>
                </tr>
              </thead>
              <tbody>
                {campaignData
                  .filter((e) => e.CAMPAIGN_ENVIRONMENT === 'PROD')
                  .map((e, i) => {
                    return (
                      <tr>
                        <td>
                          <Switch
                            bsSize={'mini'}
                            onChange={async (el, state) => {
                              const result = await updateCampaignWs(
                                {
                                  CAMPAIGN: e.CAMPAIGN,
                                  IS_ACTIVE: state ? 1 : 0,
                                  CAMPAIGN_DEL_DATE: state
                                    ? '2099-01-01'
                                    : new Date().toISOString().split('T')[0]
                                },
                                null
                              );
                              if (result)
                                setCampaignData((prevState) =>
                                  updateData(prevState, e.CAMPAIGN, state)
                                );
                            }}
                            value={e.IS_ACTIVE === 1}
                          />
                          {/* <Button
                            className={
                              e.IS_ACTIVE === 1
                                ? 'd-none'
                                : 'ml-2 btn-xs spanbox'
                            }
                            variant="outline-secondary"
                            onClick={() => deleteCampaignWs(e)}
                          >
                            {'Delete'}
                          </Button> */}
                        </td>
                        <td className='d-none d-sm-table-cell'>
                          <img
                            src={e.CAMPAIGN_IMG_B64}
                            className="img-rounded img-size-24 mr-2"
                          />
                        </td>
                        <td className='d-none d-sm-table-cell'>{e.CAMPAIGN_COUNTRY}</td>
                        <td>{e.CAMPAIGN}</td>
                        <td className='d-none d-sm-table-cell'>{e.CAMPAIGN_NAME}</td>
                        <td className='d-none d-lg-table-cell'>{e.CAMPAIGN_POINT}</td>
                        <td className='d-none d-lg-table-cell'>{e.CURRENT_BALANCE}</td>
                        <td className='d-none d-lg-table-cell'>
                          {e.CAMPAIGN_QUOTA === 9999 ||
                          e.CAMPAIGN_QUOTA_UNIT === 'N'
                            ? 'NO LIMIT'
                            : e.CAMPAIGN_QUOTA +
                              ' per ' +
                              e.CAMPAIGN_QUOTA_UNIT}
                        </td>
                        <td>
                          <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-top`}>
                                {e.CAMPAIGN_NEXT_BATCH} is Batch ID
                                <br /> isn't amount
                              </Tooltip>
                            }
                          >
                            <span className="spanbox d-none">
                              {e.CAMPAIGN_NEXT_BATCH}
                            </span>
                          </OverlayTrigger>
                          <Button
                            className="btn-xs spanbox"
                            variant={e.CAMPAIGN_NEXT_BATCH === null
                              ? 'outline-secondary'
                              : 'primary'}
                            onClick={() => handleMdSet(e)}
                          >
                            {e.CAMPAIGN_NEXT_BATCH === null
                              ? 'Set'
                              : e.CAMPAIGN_NEXT_BATCH}
                          </Button>
                          <Button
                            className="btn-xs"
                            variant="outline-secondary"
                            onClick={() => handleMdUpdate(e)}
                          >
                            + refill batch
                          </Button>
                        </td>
                        <td className='d-none d-sm-table-cell'>
                          <a className="text-muted" onClick={() => handleMdUpdate2(e)}>
                            <i className="fas fa-search" />
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </Card>
          <Card>
            <Card.Header>Purchased Spare Batch</Card.Header>
            <div className={hide}>
              <span style={{color: 'white', fontSize: 30}}>READ ONLY MODE</span>
            </div>
            <Table striped>
              <thead>
                <tr>
                  <th></th>
                  <th className='d-none d-sm-table-cell'>#</th>
                  <th>Country</th>
                  <th>Batch ID</th>
                  <th className='d-none d-lg-table-cell'>Campaign</th>
                  <th className='d-none d-lg-table-cell'>Exchange Rate</th>
                  <th className='d-none d-lg-table-cell'>Balance</th>
                  <th className='d-none d-lg-table-cell'>Quota</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {campaignData
                  .filter((e) => e.CAMPAIGN_ENVIRONMENT === 'PROD-BATCH')
                  .map((e) => {
                    return (
                      <tr>
                        <td>
                          <Switch
                            disabled
                            bsSize={'mini'}
                            onChange={(el, state) => {}}
                            value={e.IS_ACTIVE === 1}
                          />
                          <Button
                            className={
                              e.IS_ACTIVE === 1
                                ? 'd-none'
                                : 'ml-2 btn-xs'
                            }
                            variant="outline-secondary"
                            // onClick={() => deleteCampaignWs(e)}
                            onClick={() => confirmDeleteCampaignWs(e)}
                          >
                            {'Delete'}
                          </Button>
                        </td>
                        <td className='d-none d-sm-table-cell'>
                          <img
                            src={e.CAMPAIGN_IMG_B64}
                            className="img-rounded img-size-24 mr-2"
                          />
                        </td>
                        <td>{e.CAMPAIGN_COUNTRY}</td>
                        <td>{e.CAMPAIGN}</td>
                        <td className='d-none d-lg-table-cell'>{e.CAMPAIGN_NAME}</td>
                        <td className='d-none d-lg-table-cell'>{e.CAMPAIGN_POINT}</td>
                        <td className='d-none d-lg-table-cell'>{e.CURRENT_BALANCE}</td>
                        <td className='d-none d-lg-table-cell'>
                          {e.CAMPAIGN_QUOTA === 9999 ||
                          e.CAMPAIGN_QUOTA_UNIT === 'N'
                            ? 'NO LIMIT'
                            : e.CAMPAIGN_QUOTA +
                              ' per ' +
                              e.CAMPAIGN_QUOTA_UNIT}
                        </td>
                        <td>
                          <a className="text-muted" onClick={() => handleMdUpdate2(e)}>
                            <i className="fas fa-search" />
                          </a>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </Card>
        </div>
      </section>
    </div>
  );
}
